import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ReceiptItemService {


constructor(
            private http: HttpClient, 
            private global: GlobalDataService
            ) { } 


  getReceiptItemById(id: any){
        return this.http.get(this.global.httpUrl+"receipts/items?receipt_id="+id);
  }

  searchProductByAttribut(attributes: {}){
         return this.http.get(this.global.httpUrl+"products?name="+attributes['name']);
  }

  searchProductByAttributSku(attributes: {}){
         return this.http.get(this.global.httpUrl+"products?sku="+attributes['sku']);
  }

  addCart(data: any){
        return this.http.post(this.global.httpUrl+"receipts-cart/items", data); 
  }

  deleteCartItem(id: any){
         return this.http.delete(this.global.httpUrl+"receipts-cart/items/"+id);
  }

  issueInvoice(id: any){
         let data={'id' : id};
         return this.http.post(this.global.httpUrl+"receipts/"+id+'/move', data);
  } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reseipts/receipt-item.service.ts